import { Component, ViewChild, ElementRef } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, MenuItem } from 'primeng/api';
import { Table } from 'primeng/table/table';
import { ActivatedRoute, Router } from '@angular/router';
import { EtapeBonTravailEntite } from 'src/app/entites/mecanique/etape-bon-travail';
import { BaseComponent } from 'src/app/base/base-component';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ItemService } from 'src/app/services/item-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { EntretienPreventifEntite } from 'src/app/entites/mecanique/entretien-preventif';
import { EntretienCorrectifEntite } from 'src/app/entites/mecanique/entretien-correctif';
import { ListeVerificationEntite } from 'src/app/entites/mecanique/liste-verification';
import { ListeVerificationService } from 'src/app/services/liste-verification-service';
import { CategorieEntretienEntite } from 'src/app/entites/mecanique/categorie-entretien';
import { ETypeEtapeBonTravail } from 'src/app/entites/enums/type-etape-bon-travail';
import { BonTravailService } from 'src/app/services/bon-travail-service';
import { EntretienCorrectifService } from 'src/app/services/entretien-correctif-service';
import { EntretienPreventifService } from 'src/app/services/entretien-preventif-service';
import { DetailEntretienCorrectifComponent } from 'src/app/controles/mecanique/detail-entretien-correctif.component';
import { AjoutEtapeManuelleComponent, ResultatAjoutEtapeManuelle } from './ajout-etape-manuelle.component';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { EmployeEntite, enrichirRechercheEmploye } from 'src/app/entites/employe';
import { indCompleteApresChoixMecanicien } from '../etape-fait-mecanicien';

export interface ParametresSelectionEtapes {
    itemId: number;
    bonTravailId: number;
    entretienPreventifIds?: number[];
    entretienCorrectifIds?: number[];
    modeSoumission: boolean;
}

export interface ResultatSelectionEtapes {
    etapesPreventif?: EtapeBonTravailEntite[];
    etapesCorrectif?: EtapeBonTravailEntite[];
    etapesVerification?: EtapeBonTravailEntite[];
    etapesManuel?: EtapeBonTravailEntite[];
}

export interface EtapeManuelDraft {
    idTemporaire: string;
    description: string;
    categorie?: CategorieEntretienEntite;
    note?: string;
}

@Component({
    selector: 'app-selection-etapes',
    templateUrl: './selection-etapes.component.html'
})
export class SelectionEtapesComponent extends BaseComponent {

    donnees: ParametresSelectionEtapes;

    submitted: boolean;

    menu: MenuItem[];

    employes: EmployeEntite[];
    mecanicien?: EmployeEntite;
    indComplete: boolean = false;

    etapesPreventif: EtapeBonTravailEntite[] = [];
    etapesCorrectif: EtapeBonTravailEntite[] = [];
    etapesVerification: EtapeBonTravailEntite[] = [];
    etapesManuel: EtapeManuelDraft[] = [];

    entretiensPreventifs: EntretienPreventifEntite[];
    selectionentretiensPreventifs: EntretienPreventifEntite[];

    entretiensCorrectifs: EntretienCorrectifEntite[];
    selectionentretiensCorrectifs: EntretienCorrectifEntite[] = [];
    optionsCorrectif: any = {};

    listesVerification: ListeVerificationEntite[];
    selectionListesVerification: ListeVerificationEntite[];

    categoriesEntretien: CategorieEntretienEntite[];

    filtreManuel: string;

    @ViewChild('rechercheItem') inputRechercheItem;
    @ViewChild('dt') tableItems: Table;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute,
        routerService: Router,
        appMain: AppMainComponent, location: Location,
        public itemService: ItemService,
        public entretienPreventifService: EntretienPreventifService,
        public entretienCorrectifService: EntretienCorrectifService,
        public listeVerificationService: ListeVerificationService,
        public bonTravailService: BonTravailService,
        public messageService: MessageService,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, routerService, appMain);
    }

    ngOnInit() {

        this.donnees = this.config.data;
        this.employes = this.sdb.EmployesMecanique();
        this.mecanicien = undefined;
        this.employes.forEach(emp => enrichirRechercheEmploye(emp));
        this.categoriesEntretien = this.sdb.CategoriesEntretien();

        var p1 = new Promise<number>((resolve, reject) => {
            this.entretienPreventifService.ObtenirParItem(this.donnees.itemId).then(x => {
                if (this.donnees.entretienPreventifIds) {
                    this.entretiensPreventifs = x.valeur.filter(e => !this.donnees.entretienPreventifIds.includes(e.entretienPreventifId));
                } else {
                    this.entretiensPreventifs = x.valeur;
                }

                resolve(null);

            });
        });

        var p2 = new Promise<number>((resolve, reject) => {
            this.entretienCorrectifService.ObtenirParItem(this.donnees.itemId).then(x => {
                if (this.donnees.entretienCorrectifIds) {
                    this.entretiensCorrectifs = x.valeur.filter(e => !this.donnees.entretienCorrectifIds.includes(e.entretienCorrectifId) && e.statut.statutId != EStatuts.Complete && e.statut.statutId != EStatuts.EnCours);
                } else {
                    this.entretiensCorrectifs = x.valeur;
                }

                resolve(null);

            });
        });

        var p3 = new Promise<number>((resolve, reject) => {
            this.listeVerificationService.ObtenirListes().then(x => {
                this.listesVerification = x.valeur;

                resolve(null);

            });
        });


        Promise.all([p1, p2, p3]).then(x => {

            this.CompleterChargement();

            setTimeout(() => { this.inputRechercheItem?.nativeElement?.focus(); }, 100);
        });

    }

    annuler() {
        this.ref.close(null);
    }

    /** Coche Fait? lorsque Fait par reçoit un mécanicien. */
    surChoixMecanicien(mecanicien: EmployeEntite | null | undefined): void {
        this.indComplete = indCompleteApresChoixMecanicien(mecanicien, this.indComplete);
    }

    estSelectionValide(): boolean {
        return (this.selectionentretiensPreventifs?.length > 0)
            || (this.selectionentretiensCorrectifs?.length > 0)
            || (this.etapesManuel?.length > 0)
            || (this.selectionListesVerification?.length > 0);
    }

    private creerEtapeBase(): Partial<EtapeBonTravailEntite> {
        return {
            etapeBonTravailId: 0,
            indAFaire: true,
            indComplete: this.indComplete,
            mecanicien: this.mecanicien,
            optionEtapeBonTravails: []
        };
    }

    surSelection() {
        const resultat: ResultatSelectionEtapes = {};

        if (this.selectionentretiensPreventifs?.length) {
            resultat.etapesPreventif = this.selectionentretiensPreventifs.map(ent => ({
                ...this.creerEtapeBase(),
                entretienPreventif: ent,
                categorie: ent.categorie,
                description: ent.description,
                typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienPreventif),
            } as EtapeBonTravailEntite));
        }

        if (this.selectionentretiensCorrectifs?.length) {
            resultat.etapesCorrectif = this.selectionentretiensCorrectifs.map(ent => ({
                ...this.creerEtapeBase(),
                entretienCorrectif: ent,
                categorie: ent.categorie,
                description: ent.description,
                note: ent.note,
                typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienCorrectif),
            } as EtapeBonTravailEntite));
        }

        if (this.selectionListesVerification?.length) {
            resultat.etapesVerification = [];
            this.selectionListesVerification.forEach(liste => {
                liste.items.forEach(item => {
                    resultat.etapesVerification.push({
                        ...this.creerEtapeBase(),
                        itemListeVerification: item,
                        categorie: item.categorie,
                        description: item.description,
                        typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.ListeVerificaton),
                    } as EtapeBonTravailEntite);
                });
            });
        }

        if (this.etapesManuel?.length) {
            resultat.etapesManuel = this.etapesManuel.map(manuel => ({
                ...this.creerEtapeBase(),
                categorie: manuel.categorie,
                description: manuel.description,
                note: manuel.note,
                typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.Autre),
            } as EtapeBonTravailEntite));
        }

        this.ref.close(resultat);
    }

    surEntreeRecherchePreventifs() {

        if (this.tableItems.filteredValue != undefined &&
            this.tableItems.filteredValue.length == 1) {
            this.surSelectionEntretiensPreventifs([this.tableItems.filteredValue[0]]);
        }

    }

    surSelectionEntretiensPreventifs(entretiens: EntretienPreventifEntite[]) {

        var retour: ResultatSelectionEtapes = {
            etapesPreventif: entretiens.map(ent => ({
                ...this.creerEtapeBase(),
                entretienPreventif: ent,
                categorie: ent.categorie,
                description: ent.description,
                typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienPreventif),
            } as EtapeBonTravailEntite))
        };

        this.ref.close(retour);

    }

    surEntreeRechercheCorrectifs() {
        if (this.donnees.modeSoumission) { return; }

        if (this.tableItems.filteredValue != undefined &&
            this.tableItems.filteredValue.length == 1) {
            var entretiens = this.tableItems.filteredValue[0];
            var retour: ResultatSelectionEtapes = {
                etapesCorrectif: entretiens.map(ent => ({
                    ...this.creerEtapeBase(),
                    entretienCorrectif: ent,
                    categorie: ent.categorie,
                    description: ent.description,
                    note: ent.note,
                    typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.EntretienCorrectif),
                } as EtapeBonTravailEntite))
            };

            this.ref.close(retour);
        }

    }

    surSelectionEntretiensCorrectifs(event: any) {
        if (!this.optionsCorrectif[event.data.entretienCorrectifId]) {
            this.optionsCorrectif[event.data.entretienCorrectifId] = [];
            this.optionsCorrectif[event.data.entretienCorrectifId].push({
                optionEtapeBonTravailId: 0,
                description: '',
                etapeBonTravailId: 0,
                nbHeures: 0,
                montantPieces: 0
            });
        }
    }

    surDeselectionEntretiensCorrectifs(event: any) {
        delete this.optionsCorrectif[event.data.entretienCorrectifId];
    }

    nouveauEntretienCorrectif() {
        const ref = this.dialogService.open(DetailEntretienCorrectifComponent, {
            data: {
                entretienCorrectif: {
                    entretienCorrectifId: 0,
                    item: {
                        itemId: this.donnees.itemId
                    },
                    employe: this.profilService.ProfilCourant()
                }
            },
            header: `Ajouter un entretien correctif`,
            width: '75%'
        }).onClose.subscribe(res => {

            if (res) {
                if (!this.entretiensCorrectifs) {
                    this.entretiensCorrectifs = [];
                }
                this.entretiensCorrectifs.push(res);
                var selections: number[] = [];
                if (this.selectionentretiensCorrectifs) {
                    selections = this.selectionentretiensCorrectifs.map(x => x.entretienCorrectifId);
                }
                selections.push(res.entretienCorrectifId);
                this.selectionentretiensCorrectifs = this.entretiensCorrectifs.filter(x => selections.includes(x.entretienCorrectifId));

                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Entretien correctif créé.' });
            }

        });
    }

    ouvrirEtapeManuelle(etape?: EtapeManuelDraft) {
        this.dialogService.open(AjoutEtapeManuelleComponent, {
            data: {
                categoriesEntretien: this.categoriesEntretien,
                etape,
            },
            header: etape ? 'Modifier l\'étape manuelle' : 'Ajouter une étape manuelle',
            width: '32rem',
        }).onClose.subscribe((resultat: ResultatAjoutEtapeManuelle) => {
            if (!resultat) {
                return;
            }

            if (resultat.idTemporaire) {
                const existante = this.etapesManuel.find(x => x.idTemporaire === resultat.idTemporaire);
                if (existante) {
                    existante.description = resultat.description;
                    existante.categorie = resultat.categorie;
                    existante.note = resultat.note;
                }
            } else {
                this.etapesManuel.push({
                    idTemporaire: crypto.randomUUID(),
                    description: resultat.description,
                    categorie: resultat.categorie,
                    note: resultat.note,
                });
            }
        });
    }

    modifierEtapeManuel(etape: EtapeManuelDraft) {
        this.ouvrirEtapeManuelle(etape);
    }

    supprimerEtapeManuel(etape: EtapeManuelDraft) {
        this.etapesManuel = this.etapesManuel.filter(x => x.idTemporaire !== etape.idTemporaire);
    }

    filtrerEtapesManuel(): EtapeManuelDraft[] {
        if (!this.filtreManuel?.trim()) {
            return this.etapesManuel;
        }

        const filtre = this.filtreManuel.trim().toLowerCase();
        return this.etapesManuel.filter(etape =>
            etape.description?.toLowerCase().includes(filtre)
            || etape.note?.toLowerCase().includes(filtre)
            || etape.categorie?.description?.toLowerCase().includes(filtre)
            || etape.categorie?.code?.toLowerCase().includes(filtre));
    }

    surSelectionListeVerifications(listes: ListeVerificationEntite[]) {

        var retour: ResultatSelectionEtapes = {
            etapesVerification: []
        };


        listes.forEach(liste => {

            liste.items.forEach(item => {
                var etape: EtapeBonTravailEntite = {
                    ...this.creerEtapeBase(),
                    itemListeVerification: item,
                    categorie: item.categorie,
                    description: item.description,
                    typeEtapeBonTravail: this.sdb.TypeEtapeBonTravail(ETypeEtapeBonTravail.ListeVerificaton)
                } as EtapeBonTravailEntite;

                retour.etapesVerification.push(etape);
            });
        });

        this.ref.close(retour);

    }

}
